import styled from '@emotion/styled';
import { prop } from 'ramda';

import breakpoints from 'app/styles/constants/breakpoints';
import { HEADER_HEIGHT } from 'app/features/header/constants';

const { widthSmall, widthMedium } = breakpoints;

const S = {};

S.FloatingLayout = styled.div`
  label: FloatingLayout;

  --fixed-bottom-spacing: 1rem;
  --gutter: ${prop('gutterMobile')};
  --gutter-in-rem: calc(var(--gutter) * 0.0625rem);
  --top-spacing: ${props =>
    props.hasMobilePaddingTop ? 'var(--gutter-in-rem)' : 0};

  display: flex;
  flex: 1 1 auto;
  align-items: flex-start;
  justify-content: center;
  margin: ${HEADER_HEIGHT} 0 var(--fixed-bottom-spacing);
  padding: var(--top-spacing) 0 var(--gutter-in-rem);

  @media (${widthSmall}) {
    --horizontal-spacing: 2.5rem;
    --fixed-bottom-spacing: 1.5rem;
    --gutter: ${prop('gutterTablet')};
    --top-spacing: var(--gutter-in-rem);

    align-items: center;
  }

  @media (max-width: 49.9375em) and (orientation: landscape) {
    --fixed-bottom-spacing: 1rem;
    --gutter: ${prop('gutterMobile')};
    --top-spacing: ${props =>
      props.hasMobilePaddingTop ? 'var(--gutter-in-rem)' : 0};

    align-items: flex-start;
  }

  @media (${widthMedium}) {
    --fixed-bottom-spacing: 3rem;
    --gutter: ${prop('gutterDesktop')};
  }
`;

S.FloatingLayout.ContentBlock = styled.div`
  label: ContentBlock;

  --horizontal-spacing: 1.25rem;

  width: 100%;
  max-width: 77.5rem;
  padding: 0 var(--horizontal-spacing);

  @media (${widthSmall}) {
    --horizontal-spacing: 2.5rem;
  }
`;

export default S;
